import React from 'react';
import './App.css';
import { UserProvider, useUser } from './context/UserContext';
import { CartProvider } from './context/CartContext';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import AppRoutes from './components/AppRoutes';
import Sidebar from './components/Sidebar';
import Header from './components/Header';

// 🔄 временно отключаем DevRoleSwitcher
// const DevRoleSwitcher = process.env.NODE_ENV === 'development'
//   ? require('./components/DevRoleSwitcher').default
//   : () => null;

const AppContent = () => {
  const location = useLocation();
  const { user } = useUser();

  const isAuthRoute = location.pathname === '/auth' || location.pathname === '/auth/callback';

  if (isAuthRoute) {
    return <AppRoutes />;
  }

  if (user?.role === 'user') {
    return (
      <main className="min-h-screen bg-gray-900 text-white pt-4 px-6">
        <AppRoutes />
        {/* <DevRoleSwitcher /> */}
      </main>
    );
  }

  if (user?.role === 'customer') {
    return (
      <main className="min-h-screen bg-gray-900 text-white pt-4 px-6">
        <AppRoutes />
        {/* <DevRoleSwitcher /> */}
      </main>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-800">
      <Sidebar />
      <div className="flex-1 flex flex-col ml-64">
        <Header />
        <main className="flex-grow pt-16">
          <AppRoutes />
        </main>
        {/* <DevRoleSwitcher /> */}
      </div>
    </div>
  );
};

const App = () => {
  return (
    <UserProvider>
      <CartProvider>
        <Router>
          <AppContent />
        </Router>
      </CartProvider>
    </UserProvider>
  );
};

export default App;
